module.exports = __webpack_public_path__ + "static/media/top-sport-video.739670a6.mp4";